<button mat-button class="back-button" color="primary" (click)="back()" matTooltip="Home">
  <mat-icon>chevron_left</mat-icon>
</button>
